import { combineReducers } from 'redux';
import api_key from './api_key';
import user from './user';
import profile from './profile';
import account from './account';
import account_by_type from './account_by_type';
import advisory_agreements from './advisory_agreements';
import cards from './cards';
import manage_external_account from './manage_external_account';
import funding_source from './funding_source';
import funding_source_by_type from './funding_source_by_type';
import investor_application from './investor_application';
import onboarding_questions from './onboarding_questions';
import onboarding_answers from './onboarding_answers';
import eligible_account_types from './eligible_account_types';
import bank_account from './bank_account';
import institutions_search from './institutions_search';
import quotes from './quotes';
import referral_data from './referral_data';
import bank from './harmonyBank';
import billing_frequencies from './billing_frequencies';
import px_questions from './px-questions';
import dynamic_platform_tiers from './dynamic_platform_tiers';
import accountAgreements from './account_agreements';
import entitlements from './entitlements';
import stockParty from './stockParty';
export default combineReducers({
	api_key,
	account,
	account_by_type,
	advisory_agreements,
	accountAgreements,
	bank,
	bank_account,
	billing_frequencies,
	cards,
	dynamic_platform_tiers,
	entitlements,
	manage_external_account,
	funding_source,
	funding_source_by_type,
	institutions_search,
	investor_application,
	onboarding_questions,
	onboarding_answers,
	eligible_account_types,
	profile,
	quotes,
	px_questions,
	user,
	referral_data,
	stockParty,
});
